import { Box } from '@mui/material'
import { EditorContent, useEditor } from '@tiptap/react'
import type { ThreadMessage } from 'types/graphql'

import { extensionsEmbeddedAiWithMark } from '../extensions'

const sanitizeHtml = (html: string) => {
  let cleanHtml = html

  // Remove empty AI insertion spans
  cleanHtml = cleanHtml.replace(
    /<span class="tiptap-ai-insertion">\s*<\/span>/g,
    ''
  )

  // Remove empty paragraphs (with optional whitespace)
  cleanHtml = cleanHtml.replace(/<p>\s*<\/p>/g, '')

  // Remove any remaining HTML tags that might contain only whitespace
  cleanHtml = cleanHtml.replace(/<([^>]+)>\s*<\/\1>/g, '')

  return cleanHtml
}

const TiptapThreadMessage = ({ message }: { message: ThreadMessage }) => {
  const editor = useEditor({
    editable: false,
    extensions: extensionsEmbeddedAiWithMark,
    content: sanitizeHtml((message.content as any).html),
  })

  return (
    <Box className="thread-message-tiptap">
      <EditorContent editor={editor} />
    </Box>
  )
}

export default TiptapThreadMessage
